































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator.ts";
import { sassNull } from "sass";

interface SelectOption {
  value: string | any;
  label: string;
}

@Component // Asegúrate de que no falten los paréntesis
export default class FormularioConcursoPublico extends Mixins(FormValidator) {
  private nombreWeb: any = "";
  private concurso: any = "";
  private formattedFecha = "";
  private formattedRut: string | null = "";
  private comunaOptions: SelectOption[] = [];
  private cityList: any[] = [];
  private dataComuna: SelectOption = {
    value: 338,
    label: "Punta Arenas",
  };
  private dataForm: any = {
    idConcurso: null,
    rut: "",
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    fecha_nacimiento: "",
    sexo: null,
    email: "",
    telefono: "",
    calle: "",
    numero: "",
    idComuna: null,
    idDiscapacidad: null,
    medio_conocimiento_concurso: null,
    documento_cv: null,
    documento_carnet: null,
    documento_situacion_militar: null,
    documento_licencia_media: null,
    documento_anexo: null,
    documento_estudios: null,
    documento_capacitacion: null,
    documento_aptitud: null,
    documento_experiencia: null,
    documento_discapacidad: null,
  };

  private localeCalendar = {
    days: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    daysShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthsShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
  };

  private dataGenero: SelectOption = {
    value: null,
    label: "Seleccione el género",
  };

  private dataDiscapacidad: SelectOption = {
    value: null,
    label: "¿Es persona con discapacidad?",
  };

  private dataMedioComunicacion: SelectOption = {
    value: null,
    label: "¿Cómo se enteró de este concurso público?",
  };

  private discapacidadOptions: Array<SelectOption> = [
    { value: 1, label: "Si" },
    { value: 2, label: "No" },
  ];

  private generoOptions: Array<SelectOption> = [
    { value: 1, label: "Masculino" },
    { value: 2, label: "Femenino" },
    { value: 3, label: "Prefiero no decirlo" },
    { value: 4, label: "No Binarie" },
    { value: 5, label: "Otro" },
  ];

  private medioComunicacionOptions: Array<SelectOption> = [
    { value: 1, label: "Diario de circulación masiva" },
    { value: 2, label: "Familiares, amigos o conocidos" },
    { value: 3, label: "Sitio web oficial de la institución" },
    { value: 4, label: "Redes sociales (Facebook, Instagram)" },
    { value: 5, label: "Aviso en la municipalidad" },
    { value: 6, label: " Otro medio" },
  ];

  @Watch("dataGenero")
  private GeneroWatcher(newValue: any) {
    this.dataForm.sexo = newValue.value;
  }

  @Watch("dataDiscapacidad")
  private DiscapacidadWatcher(newValue: any) {
    this.dataForm.idDiscapacidad = newValue.value;
  }

  @Watch("dataComuna")
  private comunaWatcher(newValue: any) {
    this.dataForm.idComuna = newValue.value;
  }

  @Watch("dataMedioComunicacion")
  private medioWatcher(newValue: any) {
    this.dataForm.medio_conocimiento_concurso = newValue.value;
  }
  @Watch("formattedFecha")
  private edadWatcher(newValue: any) {
    const now = new Date(Date.now());
    if (typeof newValue == "object") {
      let day = newValue.getDate();
      let month = newValue.getMonth() + 1;
      let year = newValue.getFullYear();
      if (month < 10) {
        if (day < 10) {
          newValue = `0${day}/0${month}/${year}`;
        } else {
          newValue = `${day}/0${month}/${year}`;
        }
      } else {
        if (day < 10) {
          newValue = `0${day}/${month}/${year}`;
        } else {
          newValue = `${day}/${month}/${year}`;
        }
      }
    }
    var birthDate: any = "";
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1) {
        birthDate = (newValue.substring(6, 10) +
          "-" +
          newValue.substring(3, 5) +
          "-" +
          newValue.substring(0, 2) +
          " 12:00:00") as any;
      } else {
        birthDate = (newValue.substring(6, 10) +
          "-" +
          newValue.substring(3, 5) +
          "-" +
          newValue.substring(0, 2) +
          "T12:00:00") as any;
      }
    } else if (ua.indexOf("mozilla") != -1) {
      //Usa Mozilla
      birthDate = (newValue.substring(6, 10) +
        "-" +
        newValue.substring(3, 5) +
        "-" +
        newValue.substring(0, 2) +
        "T12:00:00") as any;
    }

    if (birthDate && birthDate.length <= 1) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese una fecha en formato válido (DD-MM-AAAA).",
        confirmButtonText: "Aceptar",
      });

      this.dataForm.fecha_nacimiento = null;
      return;
    }

    // --- NUEVA LÓGICA DE VALIDACIÓN 18 AÑOS ---
    const fechaNac = new Date(birthDate);
    let edad = now.getFullYear() - fechaNac.getFullYear();
    const mes = now.getMonth() - fechaNac.getMonth();

    // Ajuste por si no ha cumplido años en el año actual
    if (mes < 0 || (mes === 0 && now.getDate() < fechaNac.getDate())) {
      edad--;
    }

    if (edad < 18) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Debe ser mayor de 18 años para postular.",
        confirmButtonText: "Aceptar",
      });
      this.dataForm.fecha_nacimiento = null;
      this.formattedFecha = "";
      return; // Detenemos la ejecución
    }
    // --- FIN VALIDACIÓN ---

    let diff;
    if (birthDate instanceof Date) {
      diff = now.getTime() - birthDate.getTime();
      this.dataForm.fecha_nacimiento = birthDate;
    } else {
      diff = now.getTime() - new Date(birthDate).getTime();
      this.dataForm.fecha_nacimiento = new Date(birthDate);
    }
  }

  // @Watch("formattedFecha")
  // private edadWatcher(newValue: any) {
  //   console.log(newValue);
  //   const now = new Date(Date.now());
  //   if (typeof newValue == "object") {
  //     let day = newValue.getDate();
  //     let month = newValue.getMonth() + 1;
  //     let year = newValue.getFullYear();
  //     if (month < 10) {
  //       if (day < 10) {
  //         newValue = `0${day}/0${month}/${year}`;
  //       } else {
  //         newValue = `${day}/0${month}/${year}`;
  //       }
  //     } else {
  //       if (day < 10) {
  //         newValue = `0${day}/${month}/${year}`;
  //       } else {
  //         newValue = `${day}/${month}/${year}`;
  //       }
  //     }
  //   }
  //   var birthDate: any = "";
  //   var ua = navigator.userAgent.toLowerCase();
  //   if (ua.indexOf("safari") != -1) {
  //     if (ua.indexOf("chrome") > -1) {
  //       birthDate = (newValue.substring(6, 10) +
  //         "-" +
  //         newValue.substring(3, 5) +
  //         "-" +
  //         newValue.substring(0, 2) +
  //         " 12:00:00") as any;
  //     } else {
  //       birthDate = (newValue.substring(6, 10) +
  //         "-" +
  //         newValue.substring(3, 5) +
  //         "-" +
  //         newValue.substring(0, 2) +
  //         "T12:00:00") as any;
  //     }
  //   } else if (ua.indexOf("mozilla") != -1) {
  //     //Usa Mozilla
  //     birthDate = (newValue.substring(6, 10) +
  //       "-" +
  //       newValue.substring(3, 5) +
  //       "-" +
  //       newValue.substring(0, 2) +
  //       "T12:00:00") as any;
  //   }
  //   if (birthDate && birthDate.length <= 18) {
  //     this.$swal({
  //       icon: "warning",
  //       title:
  //         this.concurso.tipo == 1
  //           ? "Formulario Concurso Público"
  //           : "Formulario Llamado de Antecedentes",
  //       text: "Por favor, ingrese una fecha en formato válido (DD-MM-AAAA).",
  //       confirmButtonText: "Aceptar",
  //     });

  //     this.dataForm.fecha_nacimiento = null;
  //     return;
  //   }

  //   let diff;
  //   if (birthDate instanceof Date) {
  //     diff = now.getTime() - birthDate.getTime();
  //     this.dataForm.fecha_nacimiento = birthDate;
  //   } else {
  //     diff = now.getTime() - new Date(birthDate).getTime();
  //     this.dataForm.fecha_nacimiento = new Date(birthDate);
  //   }
  // }

  @Watch("formattedRut")
  private formatRut(newValue: string) {
    newValue = newValue.replace(/\./g, "");
    this.dataForm.rut = newValue;
    newValue = newValue.replace(/-/g, "");
    if (newValue.length > 5) {
      const rut = newValue
        .substring(0, newValue.length - 1)
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      const dv = newValue.substring(newValue.length - 1);
      this.formattedRut = `${rut}-${dv}`;
    } else {
      this.formattedRut = newValue
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
        .toUpperCase();
    }
  }

  private mounted() {
    if (
      this.$router.currentRoute.params.nombre &&
      this.$router.currentRoute.params.nombre != ""
    ) {
      this.nombreWeb = this.$router.currentRoute.params.nombre;
      this.getConcurso();
    }
    this.getComunas();
    if (this.dataComuna && this.dataComuna.value) {
      this.dataForm.idComuna = this.dataComuna.value;
    }
  }

  private getConcurso() {
    this.$q.loading.show({
      delay: 100, // ms
    });
    this.$axios
      .get("concurso?nombre_web=" + this.nombreWeb)
      .then((res: any) => {
        this.concurso = res.data;
        this.dataForm.idConcurso = this.concurso.id;
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
        if (err.response.data.message == "PAGINA_NO_EXISTE") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "No se han encontrando concursos públicos disponibles.",
            confirmButtonText: "Aceptar",
          });
        } else if (err.response.data.message == "CONCURSO_NOT_FOUND") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              this.concurso.tipo == 1
                ? "El concurso público no existe."
                : "El llamado de antecedentes no existe.",
            confirmButtonText: "Aceptar",
          }).then((result) => {
            this.$router.push({ name: "ConcursosPublicos" });
          });
        } else {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Ha ocurrido un error, inténtelo más tarde.",
            confirmButtonText: "Aceptar",
          }).then((result) => {
            this.$router.push({ name: "ConcursosPublicos" });
          });
        }
      });
  }

  private formatearFecha(fechaRaw: string): string {
    if (!fechaRaw) return "";

    const fecha = new Date(fechaRaw);

    // Usamos padStart para asegurar que el día y mes tengan 2 dígitos
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // Los meses van de 0 a 11
    const anio = fecha.getFullYear();

    return `${dia}-${mes}-${anio}`;
  }

  private descargarDoc(doc: any) {
    let base = process.env.VUE_APP_BASE_URL;
    const urlCompleta = `${base}${doc}`;

    window.open(urlCompleta, "_blank");
  }

  private filterFnComuna(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.comunaOptions = this.cityList.filter(
        (v) => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }

  private getComunas() {
    this.$q.loading.show({
      delay: 100, // ms
    });
    this.$axios
      .get("comunas")
      .then((res: any) => {
        res.data.forEach((city: any) => {
          this.cityList.push({
            value: city.id,
            label: city.nombre,
          });
        });
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.cityList = [];
        this.$q.loading.hide();
      });
  }

  private checkFile(file: any, fieldName: string): void {
    if (!file) return;

    // Obtenemos la extensión de forma compatible con versiones antiguas de TS
    const nombrePartes = file.name.split(".");
    const fileExtension =
      nombrePartes.length > 1
        ? nombrePartes[nombrePartes.length - 1].toLowerCase()
        : "";

    const extensions = ["jpg", "jpeg", "png", "pdf", "docx", "doc"];

    // Validamos si la extensión está en nuestra lista
    const hasValidExt = extensions.indexOf(fileExtension) !== -1;
    const hasValidSize = file.size <= 5 * 1024 * 1024; // 5MB

    if (!hasValidExt || !hasValidSize) {
      // Es vital resetear el valor en el objeto para que no se intente subir
      this.$set(this.dataForm, fieldName, null);
      this.$swal({
        icon: "warning",
        title: "Adjuntar Documentos",
        text: !hasValidExt
          ? "Formato no permitido (.jpg, .png, .pdf, .doc, .docx)"
          : "El archivo es demasiado pesado (máx 5MB)",
        confirmButtonText: "Aceptar",
      });
    } else {
      this.$set(this.dataForm, fieldName, file);
    }
  }

  private enviarPostulacion() {
    if (
      this.dataForm.rut == "" ||
      this.validateRut(this.dataForm.rut) == false
    ) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor ingrese un Rut válido.",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.nombre.trim() == "") {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor ingrese un nombre válido.",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.apellido_paterno.trim() == "") {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor ingrese un apellido paterno válido.",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.sexo == null) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, seleccione el género.",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (
      this.dataForm.fecha_nacimiento == "" ||
      this.dataForm.fecha_nacimiento == null ||
      !this.checkFecha(this.dataForm.fecha_nacimiento)
    ) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese una fecha en formato válido (DD-MM-AAAA).",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.telefono == "") {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese un teléfono.",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.telefono.length < 9) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese un teléfono válido (9 dígitos).",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.email == "") {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese un email.",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (!this.validEmail(this.dataForm.email)) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese un email válido.",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.idDiscapacidad == null) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, seleccione una opción. ¿Es persona con discapacidad?",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.medio_conocimiento_concurso == null) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text:
          "Por favor, seleccione una opción. ¿Cómo se enteró de este concurso público?",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.calle == "") {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese una calle válida",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.numero == "") {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese un número válido",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.idComuna == null) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese una comuna válida",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (
      this.dataForm.documento_discapacidad == null &&
      this.dataForm.idDiscapacidad == 1
    ) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese el certificado de discapacidad",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.documento_cv == null) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese el curriculum vitae",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.documento_carnet == null) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text:
          "Por favor, ingrese el carnet de identidad o certificacdo de nacimiento válido",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.documento_licencia_media == null) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text:
          "Por favor, ingrese certificado del nivel educacional requerido por la ley para el concurso al que postula",
        confirmButtonText: "Aceptar",
      });
      return;
    } else if (
      this.concurso.tipo == 1 &&
      this.dataForm.documento_anexo == null
    ) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text: "Por favor, ingrese anexo.",

        confirmButtonText: "Aceptar",
      });
      return;
    } else if (this.dataForm.documento_experiencia == null) {
      this.$swal({
        icon: "warning",
        title:
          this.concurso.tipo == 1
            ? "Formulario Concurso Público"
            : "Formulario Llamado de Antecedentes",
        text:
          this.concurso.tipo == 1
            ? "Por favor, ingrese documentos que acrediten experiencia laboral"
            : "Por favor, ingrese certificado de experiencia",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (!(ua.indexOf("chrome") > -1)) {
        if (this.dataForm.fecha_nacimiento.getFullYear() < 1890) {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "Por favor, ingrese una fecha en formato válido (DD-MM-AAAA).",
            confirmButtonText: "Aceptar",
          });
          return;
        }
      }
    }

    this.$q.loading.show();

    const formData = new FormData();

    // 1. Agregar campos de texto
    Object.keys(this.dataForm).forEach((key) => {
      // Si es un archivo, se maneja abajo, si es texto se agrega aquí
      if (!(this.dataForm[key] instanceof File)) {
        formData.append(key, this.dataForm[key]);
      }
    });

    // 2. Agregar archivos específicamente
    if (this.dataForm.documento_discapacidad)
      formData.append(
        "documento_discapacidad",
        this.dataForm.documento_discapacidad
      );
    if (this.dataForm.documento_cv)
      formData.append("documento_cv", this.dataForm.documento_cv);
    if (this.dataForm.documento_carnet)
      formData.append("documento_carnet", this.dataForm.documento_carnet);
    if (this.dataForm.documento_situacion_militar)
      formData.append(
        "documento_situacion_militar",
        this.dataForm.documento_situacion_militar
      );
    if (this.dataForm.documento_licencia_media)
      formData.append(
        "documento_licencia_media",
        this.dataForm.documento_licencia_media
      );
    if (this.dataForm.documento_anexo)
      formData.append("documento_anexo", this.dataForm.documento_anexo);
    if (this.dataForm.documento_estudios)
      formData.append("documento_estudios", this.dataForm.documentos_estudios);
    if (this.dataForm.documento_experiencia)
      formData.append(
        "documento_experiencia",
        this.dataForm.documento_experiencia
      );
    if (this.dataForm.documento_capacitacion)
      formData.append(
        "documento_capacitacion",
        this.dataForm.documento_capacitacion
      );
    if (this.dataForm.documento_aptitud)
      formData.append("documento_aptitud", this.dataForm.documento_aptitud);

    this.$axios
      .post("concurso", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        this.$swal({
          icon: "success",
          title:
            this.concurso.tipo == 1
              ? "Formulario Concurso Público"
              : "Formulario Llamado de Antecedentes",
          text: "Su postulación ha sido realizada correctamente.",
          confirmButtonText: "Aceptar",
        }).then((result) => {
          this.$router.push({ name: "ConcursosPublicos" });
        });
      })
      .catch((err) => {
        console.error(err);
        if (
          err.response.data.message == "INVALID_PARAM_RUT" ||
          err.response.data.message == "INVALID_RUT"
        ) {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor ingrese un Rut válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "INVALID_PARAM_NOMBRE") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor ingrese un nombre válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (
          err.response.data.message == "INVALID_PARAM_APELLIDO_PATERNO"
        ) {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor ingrese un apellido paterno válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "INVALID_PARAM_GENERO") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor, seleccione el género.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (
          err.response.data.message == "INVALID_PARAM_FECHA_NACIMIENTO"
        ) {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "Por favor, ingrese una fecha en formato válido (DD-MM-AAAA).",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "INVALID_PARAM_TELEFONO") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor, ingrese un teléfono.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "INVALID_PARAM_EMAIL") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor, ingrese un email.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "INVALID_PARAM_DISCAPACIDAD") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "Por favor, seleccione una opción. ¿Es persona con discapacidad?",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (
          err.response.data.message == "INVALID_PARAM_MEDIO_CONOCIMIENTO"
        ) {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "Por favor, seleccione una opción. ¿Cómo se enteró de este concurso público?",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "INVALID_PARAM_CALLE") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor, ingrese una calle.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "INVALID_PARAM_NUMERO") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor, ingrese un número.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "INVALID_PARAM_ID_COMUNA") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor, ingrese una comuna.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "NO_DOCUMENTO_DISCAPACIDAD") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor, ingrese el certificado de discapacidad",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "NO_DOCUMENTO_CV") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Por favor, ingrese el curriculum vitae.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "NO_DOCUMENTO_CARNET") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "Por favor, ingrese el carnet de identidad o certificado de nacimiento.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "NO_DOCUMENTO_LICENCIA") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "Por favor, ingrese certificado del nivel educacional requerido por la ley para el concurso al que postula",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "NO_DOCUMENTO_EXPERIENCIA") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              this.concurso.tipo == 1
                ? "Por favor, ingrese documentos que acrediten experiencia laboral"
                : "Por favor, ingrese certificado de experiencia",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "CONCURSO_NO_EXISTE") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              this.concurso.tipo == 1
                ? "El concurso público no existe."
                : "El llamado de antecedentes no existe.",
            confirmButtonText: "Aceptar",
          }).then((result) => {
            this.$router.push({ name: "ConcursosPublicos" });
          });
          return;
        } else if (err.response.data.message == "CONCURSO_NO_DISPONIBLE") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              this.concurso.tipo == 1
                ? "El concurso público no se encuentra disponible."
                : "El llamado de antecedentes no se encuentra disponible.",
            confirmButtonText: "Aceptar",
          }).then((result) => {
            this.$router.push({ name: "ConcursosPublicos" });
          });
          return;
        } else if (err.response.data.message == "RUT_REGISTRADO") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "El rut ingresado ya posee una postulación.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEA_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "El formato del certificado de discapacidad no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEB_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "El formato del curriculum vitae no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEC_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "El formato del carnet de identidad o certificado de nacimiento no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILED_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "El formato del certificado de nivel de estudios no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEE_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "El formato del certificado de experiencia no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEF_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text:
              "El formato del certificado de situación militar no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEG_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "El formato del anexo no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEH_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "El formato del certificado de estudios no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEI_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "El formato del certificado de capacitaciones no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else if (err.response.data.message == "FILEJ_ERROR") {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "El formato del certificado de aptitud no es válido.",
            confirmButtonText: "Aceptar",
          });
          return;
        } else {
          this.$swal({
            icon: "warning",
            title:
              this.concurso.tipo == 1
                ? "Formulario Concurso Público"
                : "Formulario Llamado de Antecedentes",
            text: "Ha ocurrido un error, inténtelo más tarde.",
            confirmButtonText: "Aceptar",
          }).then((result) => {
            this.$router.push({ name: "ConcursosPublicos" });
          });
        }
      })
      .finally(() => this.$q.loading.hide());
  }

  private checkFecha(d) {
    if (Object.prototype.toString.call(d) === "[object Date]") {
      // it is a date
      if (isNaN(d.getTime())) {
        // d.valueOf() could also work
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  private validEmail(email: string) {
    // eslint-disable-next-line
    let emailRegex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegex.test(email) === true) {
      return true;
    } else {
      return false;
    }
  }
  public validateRut(newValue: string) {
    let texto = newValue;
    let tmpstr = "";
    for (let i = 0; i < texto.length; i++)
      if (
        texto.charAt(i) != " " &&
        texto.charAt(i) != "." &&
        texto.charAt(i) != "-"
      )
        tmpstr = tmpstr + texto.charAt(i);
    texto = tmpstr;
    const largo = texto.length;
    if (largo < 2) {
      return false;
    }
    for (let i = 0; i < largo; i++) {
      if (
        texto.charAt(i) != "0" &&
        texto.charAt(i) != "1" &&
        texto.charAt(i) != "2" &&
        texto.charAt(i) != "3" &&
        texto.charAt(i) != "4" &&
        texto.charAt(i) != "5" &&
        texto.charAt(i) != "6" &&
        texto.charAt(i) != "7" &&
        texto.charAt(i) != "8" &&
        texto.charAt(i) != "9" &&
        texto.charAt(i) != "k" &&
        texto.charAt(i) != "K"
      ) {
        return false;
      }
    }
    let invertido = "";
    for (let i = largo - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + texto.charAt(i);
    let dtexto = "";
    dtexto = dtexto + invertido.charAt(0);
    dtexto = dtexto + "-";
    let cnt = 0;
    for (let i = 1, j = 2; i < largo; i++, j++) {
      //alert("i=[" + i + "] j=[" + j +"]" );
      if (cnt == 3) {
        dtexto = dtexto + ".";
        j++;
        dtexto = dtexto + invertido.charAt(i);
        cnt = 1;
      } else {
        dtexto = dtexto + invertido.charAt(i);
        cnt++;
      }
    }
    invertido = "";
    for (let i = dtexto.length - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + dtexto.charAt(i);

    if (this.revisarDigito2(texto)) {
      return true;
    }
    return false;
  }
  public revisarDigito(dvr: string) {
    const dv = dvr + "";
    if (
      dv != "0" &&
      dv != "1" &&
      dv != "2" &&
      dv != "3" &&
      dv != "4" &&
      dv != "5" &&
      dv != "6" &&
      dv != "7" &&
      dv != "8" &&
      dv != "9" &&
      dv != "k" &&
      dv != "K"
    ) {
      return false;
    }
    return true;
  }
  public revisarDigito2(crut: string) {
    const largo = crut.length;
    if (largo < 2) {
      return false;
    }
    let rut = "";
    if (largo > 2) rut = crut.substring(0, largo - 1);
    else rut = crut.charAt(0);
    const dv = crut.charAt(largo - 1);
    this.revisarDigito(dv);
    if (rut == null || dv == null) return 0;
    let dvr = "0";
    let suma = 0;
    let mul = 2;
    for (let i = rut.length - 1; i >= 0; i--) {
      suma = suma + parseInt(rut.charAt(i), 10) * mul;
      if (mul == 7) mul = 2;
      else mul++;
    }
    const res = suma % 11;
    if (res == 1) dvr = "k";
    else if (res == 0) dvr = "0";
    else {
      const dvi = 11 - res;
      dvr = dvi + "";
    }
    if (dvr != dv.toLowerCase()) {
      return false;
    }
    return true;
  }
}
